export const MAX_UINT_32 = (2 ** 32)  - 1;
export const MAX_INT_32 = (2 ** 31)  - 1;
export const TAU = Math.PI * 2;